import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { platformApi } from '@/lib/api/platform'
import { usePlatformStore } from '@/stores/platform.store'
import { Button, Input } from '@/components/ui'
import { extractApiError } from '@/lib/api'
import { usePlatformHydrated } from '@/hooks/usePlatformHydrated'

export function PlatformLoginPage() {
  const navigate = useNavigate()
  const token = usePlatformStore((s) => s.token)
  const setToken = usePlatformStore((s) => s.setToken)
  const hydrated = usePlatformHydrated()
  const [tokenInput, setTokenInput] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!hydrated) return
    if (token) {
      navigate('/platform', { replace: true })
    }
  }, [token, navigate, hydrated])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const trimmed = tokenInput.trim()
    if (!trimmed) {
      setError('Введите platform token')
      return
    }
    setLoading(true)
    setError('')
    setToken(trimmed)
    try {
      await platformApi.ping()
      navigate('/platform', { replace: true })
    } catch (err) {
      usePlatformStore.getState().clearToken()
      setError(extractApiError(err) || 'Неверный токен')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-sm">
        <h1 className="mb-1 text-xl font-semibold text-gray-900">Оператор SaaS</h1>
        <p className="mb-6 text-sm text-gray-500">
          Токен из <code className="rounded bg-gray-100 px-1 text-amber-700">PLATFORM_ADMIN_TOKEN</code> на сервере
        </p>
        {error && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="password"
            placeholder="Platform admin token"
            value={tokenInput}
            onChange={(e) => setTokenInput(e.target.value)}
            autoComplete="off"
          />
          <Button type="submit" className="w-full" isLoading={loading}>
            Войти
          </Button>
        </form>
      </div>
    </div>
  )
}
